import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

const MESSAGES = {
  VTN_DEBIT_LIMIT_EXCEEDED: (p) =>
    `Per-transaction debit limit too low: this call needs ${p?.currency || ''}${p?.required_vtn_portion} but your authorized limit is ${p?.currency || ''}${p?.authorized_limit}. Please re-authorize from your billing page.`,
  INSUFFICIENT_BALANCE: (p) =>
    `Insufficient balance: this call needs ${p?.currency || ''}${p?.required_amount}, you have ${p?.currency || ''}${p?.current_balance}. Top up to continue.`,
  BILLING_NOT_AUTHORIZED:
    'Billing authorization required. Please authorize your payment method from the billing page.',
  BILLING_NOT_CONFIGURED:
    'Billing is not configured for your account yet. Visit the billing page to set it up.',
  NO_PRICING_TIER:
    'No pricing tier is configured. Pick a plan from your billing page to use the API.',
};

// Cross-screen listener: the API call wrapper dispatches a `billing-error`
// CustomEvent on every backend 4xx that carries an error_code we recognize,
// so individual screens don't have to re-implement the same toast logic.
const BillingErrorListener = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const onBillingError = (e) => {
      const { code, payload } = e.detail || {};
      const fmt = MESSAGES[code];
      const message = typeof fmt === 'function' ? fmt(payload) : fmt;
      if (!message) return;
      enqueueSnackbar(message, {
        variant: code === 'INSUFFICIENT_BALANCE' || code === 'VTN_DEBIT_LIMIT_EXCEEDED' ? 'warning' : 'error',
        autoHideDuration: 7000,
        preventDuplicate: true
      });
    };
    window.addEventListener('billing-error', onBillingError);
    return () => window.removeEventListener('billing-error', onBillingError);
  }, [enqueueSnackbar]);

  return null;
};

export default BillingErrorListener;
